reminders = {
    init: function () {
        reminders.cE();
        reminders.eL();
    },
    cE: function cacheElements() {
        reminders.mainchecks = $('.mainchecks label input');

        reminders.form = $('form');
        reminders.phone = $('.phone');
        reminders.timezone = $('.timezone');
        reminders.quants = $('.quants');
        reminders.timeset = $('.timeset');
        reminders.required = $('.required');
        reminders.errOptErrPhone = $('.errOpt.errPhone');
        reminders.formSubmitting = $('form div#submitting');

        reminders.phoneValid = false;
        reminders.errorCount = 0;
    },
    eL: function eventListeners() {
        $(window).on('load', function () {
            $(".errOpt, .errSend").hide();
            reminders.hideAll();
        });

        reminders.mainchecks.on('change', function () {
            reminders.hideAll();

            if ( $('input[name="textReminder"]').is(':checked') ) {
                $('.timezone, .phone, .timeset, .required').show().removeClass('hidden').addClass('shown');
            }
            if ( $('input[name="textRefill"]').is(':checked') ) {
                $('.timezone, .phone, .timeset, .quants, .startdate, .required').removeClass('hidden').show().addClass('shown');
            }
        });

        //	EVENT LISTENER FOR HITTING ENTER KEY ON PHONE NUMBER FORM
        $('input[name="MobilePhone"]').on('keydown', function (e) {
            reminders.onlyAllowNumbers(e)
            reminders.checkAndAddSlashes(e);
        });

        $('button.submit').on('click', function (event) {
            event.preventDefault();
            reminders.validateForm();
        });
    },
    hideAll: function hideAll() {
        $('.phone, .timezone, .quants, .startdate, .timeset, .required').hide().removeClass('shown').addClass('hidden');
    },
    showMainchecksError: function showMainchecksError() {
        $('.errSend').show();
    },
    validateForm: function validateForm() {
        reminders.errorCount = 0;

        var phoneDirty = $('input[name="MobilePhone"]').val(),
            regEx = /^([2-9]{1})([0-9]{2})[\-\.\ ]?([0-9]{3})[-. ]?([0-9]{4})$/,
            phoneVal = phoneDirty,
            clean = phoneVal.replace(/\D/g, '');

        validatePhone.hideCustomPhoneError();

        // If there have already been 2 errors, let this pass (having already verified it's a good
        // number via regex)
        if ( validatePhone.errorCount >= 2 && (phoneVal.match(regEx) && clean.length === 10) ) {
            reminders.phoneValid = true;
        }

        reminders.validateEverythingElse();

        if ( reminders.phoneValid && reminders.errorCount === 0 ) {
            // SUBMIT
            $('form fieldset, button, .required').hide();
            reminders.formSubmitting.show();
            $('html, body').animate({
                scrollTop: reminders.formSubmitting.offset().top - 100
            }, 1000);
            reminders.submitForm();
        } else if ( phoneDirty === "" ) {
            reminders.errOptErrPhone.show();
        } else {
            var type = 'carrier';
            var json = {type: type, phone: clean};

            $.ajax({
                type: "POST",
                url: '/api/validatephone/',
                data: json,
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).done(function (d) {
                var t = d.type;
                if ( t !== "mobile" && validatePhone.errorCount < 2 ) {
                    if ( t === null ) {
                        reminders.errOptErrPhone.show();
                    }
                    validatePhone.phoneValid = false;
                    validatePhone.showCustomPhoneError(t);
                    validatePhone.errorCount++;
                    return false;
                } else if ( phoneVal.match(regEx) && clean.length === 10 ) {
                    reminders.errOptErrPhone.hide();

                    validatePhone.phoneValid = true;

                    if ( reminders.errorCount === 0 ) {
                        $('form fieldset, button, .required').hide();
                        reminders.formSubmitting.show();
                        $('html, body').animate({
                            scrollTop: reminders.formSubmitting.offset().top - 100
                        }, 1000);
                        reminders.submitForm();
                    }

                    return true;
                } else {
                    reminders.errOptErrPhone.show();
                }
            });
        }
    },
    submitForm: function () {
        var formData = $(reminders.form).serialize();
        $.ajax({
            type: "POST",
            url: '/api/reminderstext/',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).done(function () {
            reminders.formSuccess();
        }).fail(function($data){
            console.log('FAILED');
            console.log($data);
        });
    },
    formSuccess: function () {
        reminders.formSubmitting.hide();
        $('form div#success').show();
        reminders.addToDataLayer();
    },
    validateSend: function validateSend() {
        if ( !$('.mainchecks label input:checked').length ) {
            reminders.showMainchecksError();
            reminders.errorCount++
        }
    },
    validateQuant: function validateQuant() {
        if ( $('input[name="Prescription_Quantity__c"]:checked').length ) {
            $('.errOpt.errQuant').hide();
        } else {
            $('.errOpt.errQuant').show();
            reminders.errorCount++
        }
    },
    validateDate: function validateDate() {
        if ( $('input[name="startdate"]').val().length ) {
            $('.errOpt.errDate').hide();
        } else {
            $('.errOpt.errDate').show();
            reminders.errorCount++
        }
    },
    validateAmPm: function validateAmPm() {
        if ( $('input[name="ampm"]:checked').length ) {
            $('.errOpt.errAmPm').hide();
        } else {
            $('.errOpt.errAmPm').show();
            reminders.errorCount++
        }
    },
    validateEverythingElse: function validateEverythingElse() {
        reminders.validateSend();
        if ( $('input[name="textReminder"]:checked').length ) {
            reminders.validateAmPm();
        }
        if ( $('input[name="textRefill"]:checked').length ) {
            reminders.validateAmPm();
            reminders.validateQuant();
            reminders.validateDate();
        }
        return reminders.errorCount > 0;
    },
    addToDataLayer: function () {
        window.dataLayer.push({
            'event': 'refillReminders',
            'eventCategory': 'Form',
            'eventAction': 'Submit',
            'eventLabel': 'Reminder'
        })
    },
    // ONLY ALLOW NUMBERS IN PHONE NUMBER
    onlyAllowNumbers: function (evt) {
        // Allow: backspace, delete, tab, escape, enter
        if ( $.inArray(evt.key, ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Delete", "Escape", "Enter", "ArrowRight", "ArrowLeft", "Tab"]) === -1 ) {
            evt.preventDefault();
        }
    },
    // ADD SLASHES AS USER TYPES
    checkAndAddSlashes: function (evt) {

        const keyCodes = [8, 37, 38, 39, 40],
            str = evt.target.value;

        if ( $.inArray(evt.keyCode, keyCodes) === -1 ) {
            switch ( str.length ) {
                case 3:
                    $(evt.target).val(str + "-");
                    break;
                case 7:
                    $(evt.target).val(str + "-");
                    break;
                default:
                    break;
            }

        }
    }
}; // end managing
